'use client'

import { createContext, useContext, useRef, type ReactNode } from 'react'
import { useStore } from 'zustand'

import {
  createStudioFinderStore,
  type StepsType,
  type StudioFinderStore,
} from '../stores/StudioFinderStore'

type StudioFinderStoreApi = ReturnType<typeof createStudioFinderStore>

const StudioFinderStoreContext = createContext<
  StudioFinderStoreApi | undefined
>(undefined)

export function StudioFinderStoreProvider({
  children,
  initialStep = 1,
}: {
  children: ReactNode
  initialStep?: StepsType
}) {
  const storeRef = useRef<StudioFinderStoreApi | null>(null)
  storeRef.current ??= createStudioFinderStore(initialStep)

  return (
      <StudioFinderStoreContext.Provider value={storeRef.current}>
      {children}
    </StudioFinderStoreContext.Provider>
  )
}

function useStudioFinderStore<T>(
  selector: (state: StudioFinderStore) => T
): T {
  const store = useContext(StudioFinderStoreContext)
  if (!store) {
    throw new Error(
      'useStudioFinderStore must be used within StudioFinderStoreProvider'
    )
  }
  return useStore(store, selector)
}

export function useStudioFinderCurrentStep() {
  return useStudioFinderStore((state) => state.step)
}

export function useStudioFinderActions() {
  return useStudioFinderStore((state) => state.actions)
}
